import { makeRequestAction } from './index';

export const getPropertyTypes = makeRequestAction('GET_PROPERTY_TYPES', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});

export const addNewPropertyTypes = makeRequestAction('ADD_NEW_PROPERTY_TYPES');

export const deletePropertyTypes = makeRequestAction('DELETE_PROPERTY_TYPES', {
  onSuccess(params, response) {
    return {
      ids: response.map((len) => len.id),
    };
  },
});

export const updatePropertyTypes = makeRequestAction('UPDATE_PROPERTY_TYPES', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});

export const getPagePropertyTypes = makeRequestAction('GET_PAGE_PROPERTY_TYPES', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});
